import { Plugin, createApp } from 'vue';
import Alert from '@/components/Alert.vue';

interface Option {
    title: string;
    action?: (args?: any) => void;
    primary?: boolean;
}

let useAlert: () => ((options: { title?: string; message: string; actions?: Option[]; icon?: string; detail?: string}) => void);

const alert: Plugin = {
    install: () => {
        const alertRoot = createApp(Alert).mount(document.body.appendChild(document.createElement('div')));
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        useAlert = () => (alertRoot as any).displayAlert;
    }
};

export { useAlert };

export default alert;